import React from "react";
import { TenantLayout } from "./Tenant";

/**
 * Layout Components
 *
 * Following SOLID principles:
 * - Single Responsibility: Each layout has a specific purpose
 * - Open/Closed: Easy to extend with new layouts
 * - Interface Segregation: Each layout serves different use cases
 */

/**
 * App Layout - Full layout with navbar and sidebar
 * Used for unit management and detailed pages
 */
export const AppLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <TenantLayout>{children}</TenantLayout>;

/**
 * Dashboard Layout - Layout with navbar but without sidebar
 * Used for dashboard, fleet management, and overview pages
 * 
 * Note: Sidebar visibility is now handled automatically by TenantSidebar
 * - Mobile: Shows in drawer menu
 * - Desktop: Only shows on unit pages
 */
export const DashboardLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <TenantLayout>{children}</TenantLayout>;

/**
 * Mobile Layout - Minimal layout for mobile-optimized pages
 * Used for login and other mobile-specific pages
 */
export const MobileLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="min-h-screen bg-ds-dark flex flex-col">
    <main className="flex-1 overflow-x-hidden overflow-y-auto bg-ds-dark mobile-scroll">
      {children}
    </main>
  </div>
);
